import { useLayoutEffect } from "react";

import Canvas from "./Canvas";
import chart from "./chart";

function StackedBarChart(props) {
  const { refName, height, width } = props;

  useLayoutEffect(() => {
    const bar = chart({ type: "bar", ...props });
    return () => {
      bar.destroy();
    };
  }, [refName]);

  return <Canvas id={refName} name={refName} height={height} width={width} />;
}

export default StackedBarChart;
